export const AI_DATA_EXTRACTION_BANNER_CONTROL_GA_PARAMETER = 'PPA-12666-control'
export const AI_DATA_EXTRACTION_BANNER_TREATMENT_GA_PARAMETER = 'PPA-12666-treatment'

type AiDataExtractionBannerExperimentState = {
  trackingParameters?: {
    ga_cd_test_ppa: string
  }
}

export function getAiDataExtractionBannerExperimentState(
  isAiDataExtractionBannerSupported: boolean,
  isAiDataExtractionBannerEnabled: boolean
): AiDataExtractionBannerExperimentState {
  if (!isAiDataExtractionBannerSupported) {
    return {}
  }

  return {
    trackingParameters: {
      ga_cd_test_ppa: isAiDataExtractionBannerEnabled
        ? AI_DATA_EXTRACTION_BANNER_TREATMENT_GA_PARAMETER
        : AI_DATA_EXTRACTION_BANNER_CONTROL_GA_PARAMETER,
    },
  }
}
